export const ru = {
    platform: 'Показывать',
    strategy: 'Стратегия'
};
